<script lang="ts">
	import { resolve } from '$app/paths';
	import LogoLarge from '$assets/logos/vm-logo-large.svg';
	import * as m from '$paraglide/messages';

	interface Props {
		small?: boolean;
		onLogoClick?: () => void;
	}

	const { small = false, onLogoClick }: Props = $props();
</script>

<a
	href={resolve('/')}
	class={['block py-1 pr-2 shrink-0', small && 'w-11']}
	aria-label={m.action__back_home()}
	onclick={onLogoClick}
	data-sveltekit-preload-data="tap"
>
	<img class="h-9 cover-left" src={LogoLarge} alt="ViaMichelin" width="152" height="36" />
</a>
